import React from 'react';
import { FormattedMessage } from 'react-intl';

const Alert = props => {

    const { header, message, variation } = props;

    return (
        <div className={`usa-alert usa-alert-${variation} gi-alert gi-alert__${variation}`}>
            <div className="usa-alert-body gi-alert__info__body">
                <h3>
                    <FormattedMessage
                        id={ header }
                    />
                </h3>
                <div className="usa-alert-text gi-alert__info__text">
                    <FormattedMessage 
                        id={ message }
                        values={{
                            br: <br/>,
                            strong: chunks => <strong>{chunks}</strong>
                        }}
                    />
                </div>
            </div>
        </div>
    );
};

export default Alert;
